@if (journey && productGroup) {
  <div class="preview-area" id="preview-area">
    <div class="preview-header">
      <span id="journey-name">{{ journey?.latestContent?.name }}</span>
      <button
        id="close-btn"
        class="btn btn-primary"
        i18n="Close preview tab button"
        (click)="close()"
        >
      Close
    </button>
    </div>
    <ul>
      <!-- iterates all components in journey -->
      @for (step of journey?.latestContent?.components; track step; let i = $index) {
        <!-- if type is a MessageSender with an SMS, show phone with SMS and an arrow -->
        @if (step.type == 'MessageSender' && step.sms.is_shown === 'true') {
          <li [id]="step.name">
            <phone
              [message]="step"
              [screen]="'sms'"
              [isJourneyPreview]="true"
              [components]="journey?.latestContent?.components"
              [language]="journey.latestContent.language"
            ></phone>
          </li>
          @if (step.wire.is_shown === 'true') {
            <li>
              <journey-arrow [arrowType]="'straight-right'"></journey-arrow>
            </li>
          }
        }
        <!-- if type is a WorkflowEnder, show an arrow to the right -->
        @if (step.type === 'WorkflowEnder') {
          <li>
            <journey-arrow [arrowType]="'straight-right'"></journey-arrow>
          </li>
        }
        <li [id]="step.name">
          <!-- if type is a WorkflowStarter or an APITrigger, show "play" icon -->
          @if (step.type == 'WorkflowStarter' || step.type === 'APITrigger') {
            <div
              class="start"
              >
              <start></start>
            </div>
          }
          <!--
          if type is a MessageSender with a visible wire, show Phone with Wire Message.
          PhoneComponent will also recursively render any "branch" messages (MessageResponse types)
          with this message as a parent/grandparent/etc.
          -->
          @if (step.type == 'MessageSender' && step.wire.is_shown === 'true') {
            <div
              class="messages"
              >
              <!-- The actual wire message that goes with the sms-->
              <phone
                [message]="step"
                [screen]="'wire'"
                [productGroup]="productGroup"
                [recursive]="true"
                [journeyContent]="journey?.latestContent"
                [stretch]="true"
                [isJourneyPreview]="true"
                [hasIWCU]="hasIWCU"
                [components]="journey?.latestContent?.components"
                [language]="journey.latestContent.language"
              ></phone>
              <!-- display A phone for the first action that has a form -->
              @if (step.hasFormActions()) {
                <div class="form-preview">
                  @for (formAction of step.formActions(); track formAction) {
                    <phone
                      [message]="step"
                      [screen]="'form'"
                      [productGroup]="productGroup"
                      [recursive]="false"
                      [journeyContent]="journey?.latestContent"
                      [stretch]="true"
                      [isJourneyPreview]="true"
                      [hasIWCU]="hasIWCU"
                      [components]="journey?.latestContent?.components"
                      [formLabel]="formAction.label"
                      [formId]="formAction.value"
                      [language]="journey.latestContent.language"
                    ></phone>
                  }
                </div>
              }
            </div>
          }
          <!-- if type is a WorkflowDelayer with a visible wire, show "Time Delay" text & delay time span  -->
          @if (step.type === 'WorkflowDelayer') {
            <div class="delay">
              <delay [delay]="step"></delay>
            </div>
          }
          <!-- if type is a WorkflowEnder, show "stop" icon -->
          @if (step.type === 'WorkflowEnder') {
            <div class="stop">
              <stop></stop>
            </div>
          }
        </li>
        <!-- if type is a WorkflowStarter or an APITrigger, show an arrow to the right after "play" icon -->
        @if (step.type === 'WorkflowStarter' || step.type === 'APITrigger') {
          <li>
            <journey-arrow [arrowType]="'straight-right'"></journey-arrow>
          </li>
        }
      }
    </ul>
    <div class="preview-footer">
      @if (journey?.latestContent?.product_group_name) {
        <div class="footer-item">
          <span i18n="Experience product group label">Product Group: </span>
          <span id="product-group-name">{{
            journey?.latestContent?.product_group_name
          }}</span>
        </div>
      }
      @if (journey?.latestContent?.campaign) {
        <div class="footer-item">
          <span i18n="Experience campaign label">Campaign: </span>
          <span id="campaign">{{ journey?.latestContent?.campaign }}</span>
        </div>
      }
      @if (journey?.created_at) {
        <div class="footer-item">
          <span i18n="Experience date created label">Date Created: </span>
          <span id="date-created">{{
            journey?.created_at | date: 'shortDate'
          }}</span>
        </div>
      }
      @if (journey?.updated_at) {
        <div class="footer-item">
          <span i18n="Experience date modified label">Date Modified: </span>
          <span id="date-modified">{{
            journey?.updated_at | date: 'shortDate'
          }}</span>
        </div>
      }
      @if (journey?.created_by_name) {
        <div class="footer-item">
          <span i18n="Experience created by label">Created By: </span>
          <span id="created-by">{{ journey?.created_by_name }}</span>
        </div>
      }
    </div>
  </div>
}
<rn-timer-popup></rn-timer-popup>
